"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CompanyProfile_1 = require("./CompanyProfile");
exports.default = CompanyProfile_1.CompanyProfile;
